"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WildfireAbilityHandler = exports.WildfireActorAbilityFactory = exports.WildfireAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class WildfireAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Wildfire;
        this.__typeName = "Wildfire";
    }
}
exports.WildfireAbilityArgs = WildfireAbilityArgs;
let WildfireActorAbilityFactory = class WildfireActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Wildfire", "AllEnemies", 4);
    }
};
WildfireActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Wildfire")
], WildfireActorAbilityFactory);
exports.WildfireActorAbilityFactory = WildfireActorAbilityFactory;
let WildfireAbilityHandler = class WildfireAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let damages = [AbilityDamage_1.AbilityDamage.Focus("Fire", 140)];
        if (container.hasAttribute(ability.invokerId, "Charm_Druid_1")) {
            damages = [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 85),
                AbilityDamage_1.AbilityDamage.Focus("Frost", 85)
            ];
        }
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            attackType: "magic",
            abilityKey: ability.args.__typeName,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                jitter: 0,
                targetId,
                damages,
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new __1.LinkedEffectsEffectArgs([
                            new __1.BurningEffectArgs("Power", 10),
                            new __1.MaxAttributeDecreaseEffectArgs(__1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(targetId, 10, "Toughness")),
                            new __1.MaxAttributeDecreaseEffectArgs(__1.AttributeType.Will, container.getPercentOfBaseAttributeScore(targetId, 10, "Will")),
                        ], true),
                    }
                ],
            })),
            onHit: (sequence, target) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet"), "Wildfire"));
            },
        });
    }
};
WildfireAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Wildfire)
], WildfireAbilityHandler);
exports.WildfireAbilityHandler = WildfireAbilityHandler;
